export const parseCurrencyInput = (value: string): number => {
  const numericString = value.replace(/\D/g, "");
  return numericString ? parseFloat(numericString) / 100 : 0;
};
